// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#multipleselectdropdown-container {
  width: 100%;
}
#multipleselectdropdown-container .multip-select {
  position: relative;
  width: 100%;
  height: 50px;
  padding: 0px 16px;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  border-radius: 4px;
  border: 1px solid var(--dee3);
  background-color: var(--ffff);
  display: flex;
  align-items: center;
}
#multipleselectdropdown-container .multip-select .not-selected {
  color: #8f8e8e;
}
#multipleselectdropdown-container .multip-select .option-popup {
  width: 100%;
  position: absolute;
  left: 0;
  top: 55px;
  background-color: var(--ffff);
  border-radius: 4px;
  padding: 0px 0px;
  z-index: 999;
}
#multipleselectdropdown-container .multip-select .option-popup .list-op {
  padding: 10px 12px 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--e3e3);
}
#multipleselectdropdown-container .multip-select .option-popup .list-op:last-child {
  border-bottom: unset;
}
#multipleselectdropdown-container .multip-select .option-popup .list-op:hover {
  background-color: var(--56ff);
  color: var(--ffff);
}
#multipleselectdropdown-container .multip-select .option-popup .list-op:hover #checkbox-container .form-check-input:checked {
  border-color: var(--ffff) !important;
}

#multipleselectdropdown-container-dark {
  width: 100%;
}
#multipleselectdropdown-container-dark .multip-select {
  position: relative;
  width: 100%;
  height: 50px;
  padding: 0px 16px;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  border-radius: 4px;
  background-color: var(--4d6c);
  display: flex;
  align-items: center;
  color: var(--ffff);
}
#multipleselectdropdown-container-dark .multip-select .not-selected {
  color: var(--c9c9);
}
#multipleselectdropdown-container-dark .multip-select .option-popup {
  width: 100%;
  position: absolute;
  left: 0;
  top: 55px;
  background-color: #606499;
  border-radius: 4px;
  padding: 0px 0px;
  z-index: 999;
}
#multipleselectdropdown-container-dark .multip-select .option-popup .list-op {
  padding: 10px 12px 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--e3e3);
  color: var(--ffff);
}
#multipleselectdropdown-container-dark .multip-select .option-popup .list-op:last-child {
  border-bottom: unset;
}
#multipleselectdropdown-container-dark .multip-select .option-popup .list-op:hover {
  background-color: var(--4d6c);
  color: var(--ffff);
}
#multipleselectdropdown-container-dark .multip-select .option-popup .list-op:hover #checkbox-container .form-check-input:checked {
  border-color: var(--2b4e) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/inputs/Multipleselectdropdown/Multipleselectdropdown.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EAEA,kBAAA;EACA,6BAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;AACJ;AAAI;EACE,cAAA;AAEN;AAAI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAEN;AADM;EACE,4BAAA;EACA,eAAA;EACA,oCAAA;AAGR;AAFQ;EACE,oBAAA;AAIV;AAFQ;EACE,6BAAA;EACA,kBAAA;AAIV;AAHU;EACE,oCAAA;AAKZ;;AAOA;EACE,WAAA;AAJF;AAKE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAJJ;AAKI;EACE,kBAAA;AAHN;AAKI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EAEA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAJN;AAKM;EACE,4BAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;AAHR;AAIQ;EACE,oBAAA;AAFV;AAIQ;EACE,6BAAA;EACA,kBAAA;AAFV;AAGU;EACE,oCAAA;AADZ","sourcesContent":["#multipleselectdropdown-container {\r\n  width: 100%;\r\n  .multip-select {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 50px;\r\n    padding: 0px 16px;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    font-family: \"f-400\";\r\n    // line-height: 19.5px;\r\n    border-radius: 4px;\r\n    border: 1px solid var(--dee3);\r\n    background-color: var(--ffff);\r\n    display: flex;\r\n    align-items: center;\r\n    .not-selected {\r\n      color: #8f8e8e;\r\n    }\r\n    .option-popup {\r\n      width: 100%;\r\n      position: absolute;\r\n      left: 0;\r\n      top: 55px;\r\n      background-color: var(--ffff);\r\n      border-radius: 4px;\r\n      padding: 0px 0px;\r\n      z-index: 999;\r\n      .list-op {\r\n        padding: 10px 12px 10px 12px;\r\n        cursor: pointer;\r\n        border-bottom: 1px solid var(--e3e3);\r\n        &:last-child {\r\n          border-bottom: unset;\r\n        }\r\n        &:hover {\r\n          background-color: var(--56ff);\r\n          color: var(--ffff);\r\n          #checkbox-container .form-check-input:checked {\r\n            border-color: var(--ffff) !important;\r\n          }\r\n        }\r\n      }\r\n      // .actiove-op {\r\n      // background-color: var(--56ff);\r\n      // color: var(--ffff);\r\n      // }\r\n    }\r\n  }\r\n}\r\n\r\n#multipleselectdropdown-container-dark {\r\n  width: 100%;\r\n  .multip-select {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 50px;\r\n    padding: 0px 16px;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    font-family: \"f-400\";\r\n    border-radius: 4px;\r\n    // border: 1px solid var(--dee3);\r\n    background-color: var(--4d6c);\r\n    display: flex;\r\n    align-items: center;\r\n    color: var(--ffff);\r\n    .not-selected {\r\n      color: var(--c9c9);\r\n    }\r\n    .option-popup {\r\n      width: 100%;\r\n      position: absolute;\r\n      left: 0;\r\n      top: 55px;\r\n      // background-color: var(--2b4e);\r\n      background-color: #606499;\r\n      border-radius: 4px;\r\n      padding: 0px 0px;\r\n      z-index: 999;\r\n      .list-op {\r\n        padding: 10px 12px 10px 12px;\r\n        cursor: pointer;\r\n        border-bottom: 1px solid var(--e3e3);\r\n        color: var(--ffff);\r\n        &:last-child {\r\n          border-bottom: unset;\r\n        }\r\n        &:hover {\r\n          background-color: var(--4d6c);\r\n          color: var(--ffff);\r\n          #checkbox-container .form-check-input:checked {\r\n            border-color: var(--2b4e) !important;\r\n          }\r\n        }\r\n      }\r\n      // .actiove-op {\r\n      // background-color: var(--56ff);\r\n      // color: var(--ffff);\r\n      // }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
